import { quantum } from 'ldrs'
import '../../../static/styles/loading.css';
import React, { useEffect, useState } from 'react';
import { LinearProgress, Snackbar, Alert, Box, Button, Typography } from '@mui/material';

quantum.register()

const Loading = ({ isLoaded }) => {
  const [progress, setProgress] = useState(0);
  const [showReloadMessage, setShowReloadMessage] = useState(false);

  useEffect(() => {
    let interval;
    interval = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress >= 97) {
            return 97;
          }
          const diff = Math.random() * 10;
          return Math.min(oldProgress + diff, 97);
        });
      }, 800);
    if (isLoaded) {
      const timeout = setTimeout(() => {
        setShowReloadMessage(true);
      }, 60000);

      return () => {
        clearInterval(interval);
        clearTimeout(timeout);
      };
    }
  }, [isLoaded]);

  

  const handleReload = () => {
    setShowReloadMessage(false);
  };

  return (
    <Box className='loading-animation'> 
        {!isLoaded && 
            (<><l-quantum
                size="200"
                speed="1.75"
                color="#F0BE41" 
                class="loading-animation"
            />
            <Box className='loading-bar-container'>
            <LinearProgress 
                variant="determinate" 
                value={progress} 
                sx={{height:'1.5vh'}} // desgraciadamente hay que hacer esto para controlar la altura
                className='loading-bar' 
            />
            <Typography className="loading-percentage">
                {`${Math.round(progress)}%`}
            </Typography>
            </Box></>)
        }
        <Snackbar 
            open={showReloadMessage} 
            autoHideDuration={1000} 
            onClose={() => setShowReloadMessage(false)}
            anchorOrigin={{vertical: 'bottom', horizontal:'center'}}
        >
        <Alert 
            onClose={() => setShowReloadMessage(false)} 
            severity="warning" 
            className='reload-alert'
            action={
                <Button 
                    color="inherit" 
                    size="small" 
                    onClick={handleReload}
                    className='reload-button'
                >
                    Recargar
                </Button>
            }
        >
          Network error, please reload the page
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Loading;

